import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import placeholderProfileImgUrl from '@assets/image/img_profile_default.svg';

const AvatarWrapper = styled.div`
  display: inline-block;
  ${({ borderSize }) => `
  width: ${borderSize}px;
  height: ${borderSize}px;
`};
  overflow: hidden;
  border-radius: 50%;
`;

const AvatarImage = styled.img`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  cursor: pointer;

  :before {
    content: '';
    display: block;
    position: relative;
    ${({ borderSize }) => `
    width: ${borderSize}px;
    height: ${borderSize}px;
  `};
    background-image: url(${placeholderProfileImgUrl});
  }
`;

const Avatar = ({ avatarUrl, borderSize, ...props }) => {
  return (
    <AvatarWrapper borderSize={borderSize} {...props}>
      {avatarUrl ? (
        <AvatarImage src={avatarUrl} borderSize={borderSize} />
      ) : (
        <img
          src={placeholderProfileImgUrl}
          width={borderSize}
          height={borderSize}
          style={{ cursor: 'pointer' }}
        />
      )}
    </AvatarWrapper>
  );
};

Avatar.propTypes = {
  avatarUrl: PropTypes.string,
  borderSize: PropTypes.number,
};

export default Avatar;
